import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import {
  transformLoadWorkItemResponseToWorkItemDetails,
  transformLoadWorkItemsResponseToWorkItemsListing,
  transformWorkItemsListingFilterValuesToLoadWorkItemsRequest,
} from "../mappers";
import {
  WorkItemDetailsRecord,
  WorkItemUuid,
  WorkItemsRecordsListing,
  WorkItemsRecordsListingFilterValues,
} from "../types";

export const workItemsApi = createApi({
  reducerPath: "@work-items/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  tagTypes: ["WorkItemsRecordsListing", "WorkItemDetailsRecord"],
  endpoints: (builder) => {
    return {
      loadWorkItemsListing: builder.query<WorkItemsRecordsListing, WorkItemsRecordsListingFilterValues>({
        query: (values) => {
          return {
            url: "/workItem/list",
            method: "POST",
            body: transformWorkItemsListingFilterValuesToLoadWorkItemsRequest(values),
          };
        },
        transformResponse: transformLoadWorkItemsResponseToWorkItemsListing,
        providesTags: ["WorkItemsRecordsListing"],
      }),
      loadWorkItemDetailsRecord: builder.query<WorkItemDetailsRecord, WorkItemUuid>({
        query: (uuid) => {
          return {
            url: `/getWorkItem/${uuid}`,
            method: "POST",
          };
        },
        transformResponse: transformLoadWorkItemResponseToWorkItemDetails,
        providesTags: ["WorkItemDetailsRecord"],
      }),
    };
  },
});
